import React, { useEffect, useState } from "react";
// import { FaPhoneAlt } from "react-icons/fa";
import { FaMobileAlt, FaEnvelope, FaUser } from "react-icons/fa";
import Link from "next/link";
import { useStoreLogin } from "../../store/login";
import { FaSortDown } from "react-icons/fa6";
import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";

const Both = dynamic(() => import("../login/Both"), { ssr: false });

const Topbar = ({ topNav }) => {
  const user = useStoreLogin.getState().user;
  const authToken = useStoreLogin.getState().authToken;
  const baseUrl = process.env.NEXT_PUBLIC_SITE_URL;
  const [isClient, setIsClient] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [active, setActive] = useState(false);
  const [initialScreen, setInitialScreen] = useState(null);
  const client = useStoreLogin.getState().user?.client;
  const DashboardUrl = `${baseUrl}/auth/login/redirect?token=${authToken}&path=student/dashboard&client=${client}`;
  const { logout } = useStoreLogin();
  useEffect(() => {
    setIsClient(true);
  }, []);
  const handleLogout = () => {
    logout();
  };

  const pathName = usePathname();

  return (
    <>
      {pathName === "/home" ? null : (
        <div>
          <Modal
            className="buy-dialog lg:max-w-xl md:max-w-lg"
            isOpen={isOpen}
            onOpenChange={(open) => setIsOpen(open)}
          >
            <ModalContent>
              {(onClose) => (
                <div className="card flex justify-center p-0">
                  <div className="top-5 sm:top-10 w-full">
                    <Both initialScreen={initialScreen} />
                  </div>
                </div>
              )}
            </ModalContent>
          </Modal>

          <div className="bg-color flex items-center">
            <div className="container">
              <div className="lg:grid grid-cols-12  py-2 hidden">
                {topNav?.menus?.Top_Menu_1?.title && (
                  <div
                    className="col-span-5 flex items-center border-r-1 pr-2 border-white"
                    style={{ fontFamily: "Poppins, sans-serif" }}
                  >
                    <div className="xl:text-sm text-xs font-semibold  ">
                      <p>{topNav?.menus?.Top_Menu_1?.title}</p>
                    </div>
                  </div>
                )}
                {(topNav?.website?.contactNumber?.length > 0 ||
                  topNav?.website?.email?.length > 0) && (
                  <div className="lg:col-span-4 col-span-6 flex lg:items-center justify-end">
                    <div className="flex  items-center justify-between gap-4">
                      {topNav.website.contactNumber[0] && (
                        <div className="flex items-center gap-1">
                          <div className="mx-1">
                            <FaMobileAlt className="font-bold text-xs" />
                          </div>
                          <Link
                            href={`tel:${topNav.website.contactNumber[0]}`}
                            className="text-sm font-medium"
                          >
                            <span>{topNav.website.contactNumber[0]}</span>
                            <span className="text-white border-r-1 pr-2 border-white"></span>
                          </Link>
                        </div>
                      )}
                      {topNav?.website?.email[0] && (
                        <div className="flex items-center gap-1 ml-4">
                          <div className="mx-1">
                            <FaEnvelope className="font-bold text-xs" />
                          </div>
                          <Link
                            href={`mailto:${topNav?.website?.email[0]}`}
                            className="text-sm font-medium"
                          >
                            <span>{topNav?.website?.email[0]}</span>
                          </Link>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                <div className="lg:col-span-3 col-span-6 flex lg:items-center justify-end">
                  {isClient && user && authToken ? (
                    <div className="border-1 px-2 py-0.5 text-xs font-medium border-black relative">
                      <div className="flex items-center justify-center gap-1">
                        <div className="w-4 h-4 rounded-full bg-blue-800 text-white flex justify-center items-center p-2">
                          {user?.firstName?.charAt(0) || user?.firstName}
                        </div>
                        <FaSortDown
                          onClick={() => setActive((prev) => !prev)}
                        />
                      </div>

                      {active && (
                        <ul className="btn text-xs  gap-4  bg-white absolute right-0 border-1 shadow-lg z-10 px-2 w-[155px]">
                          <li className="py-2 flex items-center gap-1">
                            <FaUser />
                            <span className="">{user.firstName}</span>
                          </li>
                          <li className="py-2">
                            <Link
                              href={DashboardUrl}
                              target="_blank"
                              className=" px-2 py-0.5  "
                            >
                              DashBoard
                            </Link>
                          </li>

                          <li className="pb-4">
                            <button
                              onClick={handleLogout}
                              className=" px-2 py-0.5  "
                            >
                              Logout
                            </button>
                          </li>
                        </ul>
                      )}
                    </div>
                  ) : (
                    <div className="btn text-sm flex gap-4">
                      <button
                        onClick={() => {
                          setInitialScreen("LOGIN");
                          setIsOpen(true);
                        }}
                        className="border-1 px-2 py-0.5 text-xs font-medium border-black"
                      >
                        CLC Login
                      </button>
                      <button
                        onClick={() => {
                          setInitialScreen("REGISTER");
                          setIsOpen(true);
                        }}
                        className="border-1 px-2 py-0.5 text-xs font-medium border-black"
                      >
                        Signup
                      </button>
                      {/* <Link
                    href="https://lms.clclive.in/auth/login"
                    className="border-1 px-2 py-0.5 text-xs font-medium border-black"
                  >
                    CHS Login
                  </Link> */}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Topbar;
